define('widgets/dgrid/blocks/reelRaces/reelRaces',[
   'underscore',
   'knockout'
], function (_, ko) {

    var ReelRaces = function (tournamentCampaignsViewModel, getFields) {
        var self = this,
            activeCampaign = tournamentCampaignsViewModel.activeCampaign();

        self.nextTournament = activeCampaign.nextTournament;
        self.isClicked = ko.observable(false);
        self.buttonText = getFields('opt_in_cta_you_are_in');

    };

    return ReelRaces;
});

